<template>
  <div class="margin-subpages">
    <div class="fs-18 fw-700">Click icon for copy image tag to clipboard</div>
    <div class="icons-table">
      <div
        v-for="value in iconList"
        :key="'icon_' + value"
        @click.prevent="copyURL(value)"
        class="icon-body my-12 mr-12"
      >
        <a
          :href="value"
          class="center"
          style="text-decoration: none"
          target="_blank"
          rel="noopener noreferrer"
          ref="mylink"
        >
          <div class="m-auto">
            <img
              class="icon-image"
              :src="$utils('icons', value)"
              :title="value"
              :alt="value"
            />
          </div>
          <div
            class="fc-000000 opa-07 fs-10 mt-4 ellipsis"
            style="max-width: 100px;"
            :title="value"
          >
            {{ value }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "icons",
  data() {
    return {
      iconList: [
        "arrow_down_red_24dp",
        "arrow_down_red_24dp@2x",
        "arrow_down_white_32dp",
        "arrow_down_white_32dp@2x",
        "arrow_up_green_24dp",
        "arrow_up_green_24dp@2x",
        "arrow_up_white_32dp",
        "arrow_up_white_32dp@2x",
        "chart_active_24dp",
        "chart_active_24dp@2x",
        "chart_inactive_24dp",
        "chart_inactive_24dp@2x",
        "chevron_black_left",
        "chevron_black_left@2x",
        "chevron_black_right",
        "chevron_black_right@2x",
        "chevron_white_left_32px",
        "chevron_white_left_32px@2x",
        "chevron_white_right_32px",
        "chevron_white_right_32px@2x",
        "date_white_24dp",
        "date_white_24dp@2x",
        "delete_black_24dp",
        "delete_black_24dp@2x",
        "Distractors_16",
        "Distractors_16@2x",
        "Engagement_Highly_Engaged_32",
        "Engagement_Highly_Engaged_32@2x",
        "Engagement_In-Active_32",
        "Engagement_In-Active_32@2x",
        "Engagement_Moderately_Engaged_32",
        "Engagement_Moderately_Engaged_32@2x",
        "Engagement_Somewhat_Engaged_32",
        "Engagement_Somewhat_Engaged_32@2x",
        "Engagement_Under_Engaged_32",
        "Engagement_Under_Engaged_32@2x",
        "filter-list-24px",
        "filter-list-24px@2x",
        "flag_purple_20dp",
        "flag_purple_20dp@2x",
        "groups_black_32dp_30",
        "groups_black_32dp_30@2x",
        "Happiness_Rate_24",
        "Happiness_Rate_24@2x",
        "ic_bolt_black_24dp",
        "ic_bolt_black_24dp@2x",
        "ic_bolt_purple_24dp",
        "ic_bolt_purple_24dp@2x",
        "ic_bolt_white_24dp",
        "ic_bolt_white_24dp@2x",
        "ic_criticalthinking",
        "ic_criticalthinking@2x",
        "ic_empathy",
        "ic_empathy@2x",
        "ic_flat_coin",
        "ic_flat_coin@2x",
        "ic_flat_gem",
        "ic_flat_gem@2x",
        "ic_happily",
        "ic_happily@2x",
        "ic_help_gray_24px",
        "ic_help_gray_24px@2x",
        "ic_help_outline-16px",
        "ic_help_outline-16px@2x",
        "ic_help_white_24px",
        "ic_help_white_24px@2x",
        "ic_initiative",
        "ic_initiative@2x",
        "ic_leadership",
        "ic_leadership@2x",
        "ic_optimism",
        "ic_optimism@2x",
        "ic_org_chart_24px",
        "ic_org_chart_24px@2x",
        "ic_preview",
        "ic_preview@2x",
        "ic_profile_coin",
        "ic_profile_coin@2x",
        "ic_profile_gem",
        "ic_profile_gem@2x",
        "ic_selfawareness",
        "ic_selfawareness@2x",
        "ic_star_24px",
        "ic_star_24px@2x",
        "ic_star_gray_24px",
        "ic_star_gray_24px@2x",
        "ic_twotone_cal",
        "ic_twotone_cal@2x",
        "ic_twotone_clock",
        "ic_twotone_clock@2x",
        "ic_twotone_location",
        "ic_twotone_location@2x",
        "ic_xls_download",
        "ic_xls_download@2x",
        "key_white_24dp",
        "key_white_24dp@2x",
        "lock_white_24dp",
        "lock_white_24dp@2x",
        "Medals_32",
        "Medals_32@2x",
        "no_change_white_32dp",
        "no_change_white_32dp@2x",
        "open_in_new_gray_24px",
        "open_in_new_gray_24px@2x",
        "open_in_new_white_24dp",
        "open_in_new_white_24dp@2x",
        "Open-ended_Feedback_24",
        "Open-ended_Feedback_24@2x",
        "Outstanding_32",
        "Outstanding_32@2x",
        "Passives_16",
        "Passives_16@2x",
        "Promoters_16",
        "Promoters_16@2x",
        "Risk_Rate_v1_24",
        "Risk_Rate_v1_24@2x",
        "Risk_Rate_v2_24",
        "Risk_Rate_v2_24@2x",
        "Risk_Rate_v3_24",
        "Risk_Rate_v3_24@2x",
        "same_score_24dp",
        "same_score_24dp@2x",
        "Super_Star_32",
        "Super_Star_32@2x",
        "visibility_black_24dp",
        "visibility_black_24dp@2x",
        "visibility_off_black_24dp",
        "visibility_off_black_24dp@2x",
      ],
    };
  },
  methods: {
    copyURL(value) {
      // :src="$utils('icons', 'image')"
      const imageTag = `<img :src="$utils('icons', '${value}')" alt="icons_${value}" />`;
      const clipboardData = window.clipboardData || navigator.clipboard;
      clipboardData.writeText(imageTag);
      this.$message({
        message: "Copy image " + value + " to clipboard.",
        type: "success",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-image {
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
  background-color: #efefef;
  transition: 0.2s;
  &:hover {
    margin-bottom: 4px;
    box-shadow: 0px 6px 6px #00000019;
  }
}
.icon-body {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.icons-table {
  display: grid;
  grid-template-columns: 16.5% 16.5% 16.5% 16.5% 16.5% 16.5%;
}
</style>